import React, { Component } from 'react';
import AppShell from '../AppShell';
import Attachments from './Attachments';
import EmptyState from '../EmptyState';
import NewReply from './NewReply';
import TicketReplies from './TicketReplies';
import { Link } from 'react-router-dom';
import { Localized } from '@fluent/react';
import { prettyDate } from '../../tools/date';
import './Ticket.scss';
import { addTicket, getTickets, updateTicket } from '../../dbTicket';
import postTranslations from '../../controllers/postTranslation';
import { Button } from 'reactstrap';
import { ReactComponent as Globe } from '../../assets/globe-alt.svg';
import { descending } from 'd3';

export default class Ticket extends Component {
  state = {
    translateLoading: false,
    ticketTranslatedTitle: '',
    ticketTranslatedDescription: '',
    ticketCached: [],
    clickedShowOriginal: false,
    clickedTranslate: false,
  };

  statusIcon(status) {
    switch (status.name) {
      case 'New':
        return (
          <div className="ticket-status-wrapper">
            Status:{' '}
            <i className="fa fa-clock-o ticket-clock fa-2x ticket-icon" />
          </div>
        );
      case 'Pending':
        return (
          <div className="ticket-status-wrapper">
            Status:{' '}
            <i className="fa fa-refresh ticket-refresh fa-spin fa-2x ticket-icon" />
          </div>
        );
      case 'Closed':
        return (
          <div className="ticket-status-wrapper">
            Status:
            <i className="fa fa-check-circle-o ticket-check fa-2x ticket-icon" />
          </div>
        );
      default:
        return null;
    }
  }

  populateTickets = () => {
    const paramId = parseInt(this.props.match.params.id);
    const result = getTickets();
    result.then(data => this.setState({ ticketCached: data }));
    result.then(data => {
      if (data.length > 0) {
        const filteredTicket =
          data.length > 0 && data.filter(item => item.idTicket === paramId)[0];
        this.setState({
          ticketTranslatedTitle: filteredTicket?.title,
        });
        this.setState({
          ticketTranslatedDescription: filteredTicket?.description,
        });
      }
    });
  };

  compareUpdateDate = () => {
    const { ticket } = this.props;
    const paramId = parseInt(this.props.match.params.id);
    const result = getTickets();
    result.then(data => {
      if (data.length > 0) {
        const filteredTicket =
          data.length > 0 && data.filter(item => item.idTicket === paramId)[0];
        const dateFiltered = Math.floor(
          new Date(filteredTicket?.updateDate).getTime() / 1000
        );
        const ticketDate = Math.floor(
          new Date(ticket?.created_date).getTime() / 1000
        );
        if (dateFiltered !== ticketDate && !isNaN(ticketDate)) {
          this.getTranslactionsUpdate();
        }
      }
    });
  };

  getTranslactions = () => {
    const { ticket } = this.props;
    const lang = localStorage.getItem('language');
    const language = lang.split('-')[0];
    const ticketToTranslate = {
      title: ticket?.subject,
      description: ticket?.description,
    };
    if (lang !== 'it-IT') {
      this.setState({ translateLoading: true });
      postTranslations(
        {
          title: ticketToTranslate.title,
          description: ticketToTranslate.description,
        },
        language
      ).then(res => {
        if (
          !res ||
          (res && res.ok === false) ||
          (res && res?.status >= 400 && res?.status < 600)
        ) {
          this.setState({
            ticketTranslatedTitle: ticketToTranslate.title,
          });
          this.setState({
            ticketTranslatedDescription: ticketToTranslate.description,
          });
          this.setState({ translateLoading: false });
        } else {
          addTicket({
            title: res?.translation?.title,
            description: res?.translation?.description,
            idTicket: ticket.id,
            updateDate: ticket.created_date,
          });
          this.populateTickets();
          this.setState({ translateLoading: false });
        }
      });
    }
  };

  getTranslactionsUpdate = () => {
    const { ticket } = this.props;
    const lang = localStorage.getItem('language');
    const language = lang.split('-')[0];
    const ticketToTranslate = {
      title: ticket?.subject,
      description: ticket?.description,
    };
    if (lang !== 'it-IT') {
      this.setState({ translateLoading: true });
      postTranslations(
        {
          title: ticketToTranslate.title,
          description: ticketToTranslate.description,
        },
        language
      ).then(res => {
        if (
          !res ||
          (res && res.ok === false) ||
          (res && res?.status >= 400 && res?.status < 600)
        ) {
          this.setState({
            ticketTranslatedTitle: ticketToTranslate.title,
          });
          this.setState({
            ticketTranslatedDescription: ticketToTranslate.text,
          });
          this.setState({ translateLoading: false });
        } else {
          updateTicket(ticket.id, {
            title: res?.translation?.title,
            description: res?.translation?.description,
            idTicket: ticket.id,
            updateDate: ticket.created_date,
          });
          this.populateTickets();
          this.setState({ translateLoading: false });
        }
      });
    }
  };

  componentDidMount() {
    const lang = localStorage.getItem('language');
    if (lang !== 'it-IT') {
      this.populateTickets();
      this.compareUpdateDate();
    }
  }

  componentDidUpdate(prevProps) {
    const { ticketCached } = this.state;
    if (this.props.ticket?.id !== prevProps.ticket?.id) {
      const { ticket } = this.props;
      const filteredTicket =
        ticketCached.length > 0 &&
        ticketCached.filter(item => item.idTicket === ticket.id)[0];
      if (!filteredTicket) {
        this.getTranslactions();
      } else {
        const dateFiltered = Math.floor(
          new Date(filteredTicket.updateDate).getTime() / 1000
        );
        const ticketDate = Math.floor(
          new Date(ticket.created_date).getTime() / 1000
        );
        if (dateFiltered !== ticketDate) {
          this.getTranslactionsUpdate();
        }
      }
    }
  }

  showOriginal = () => {
    const { ticket } = this.props;
    this.setState({
      ticketTranslatedTitle: ticket?.subject,
    });
    this.setState({
      ticketTranslatedDescription: ticket?.description,
    });
    this.setState({ clickedShowOriginal: true });
    this.setState({ clickedTranslate: false });
  };

  translateTicket = () => {
    this.setState({ clickedShowOriginal: false });
    this.setState({ clickedTranslate: true });
    const paramId = parseInt(this.props.match.params.id);
    const { ticket } = this.props;
    const lang = localStorage.getItem('language');
    const language = lang === 'it-IT' ? 'en' : lang.split('-')[0];
    const ticketToTranslate = {
      title: ticket?.subject,
      description: ticket?.description,
    };
    const result = getTickets();
    result.then(data => {
      if (data.length > 0) {
        const filteredTicket =
          data.length > 0 && data.filter(item => item.idTicket === paramId)[0];
        if (ticket.id !== filteredTicket?.idTicket) {
          this.setState({ translateLoading: true });
          postTranslations(
            {
              title: ticketToTranslate.title,
              description: ticketToTranslate.description,
            },
            language
          ).then(res => {
            if (
              !res ||
              (res && res.ok === false) ||
              (res && res?.status >= 400 && res?.status < 600)
            ) {
              this.setState({
                ticketTranslatedTitle: ticketToTranslate.title,
              });
              this.setState({
                ticketTranslatedText: ticketToTranslate.description,
              });
              this.setState({ translateLoading: false });
            } else {
              addTicket({
                title: res?.translation?.title,
                description: res?.translation?.description,
                idTicket: ticket.id,
                updateDate: ticket.created_date,
              });
              this.populateTickets();
              this.setState({ translateLoading: false });
            }
          });
        } else {
          const dateFiltered = Math.floor(
            new Date(filteredTicket?.updateDate).getTime() / 1000
          );
          const ticketDate = Math.floor(
            new Date(ticket.created_date).getTime() / 1000
          );
          if (dateFiltered !== ticketDate) {
            this.setState({ translateLoading: true });
            postTranslations(
              {
                title: ticketToTranslate.title,
                description: ticketToTranslate.description,
              },
              language
            ).then(res => {
              if (
                !res ||
                (res && res.ok === false) ||
                (res && res?.status >= 400 && res?.status < 600)
              ) {
                this.setState({
                  ticketTranslatedTitle: ticketToTranslate.title,
                });
                this.setState({
                  ticketTranslatedDescription: ticketToTranslate.description,
                });
                this.setState({ translateLoading: false });
              } else {
                updateTicket(ticket.id, {
                  title: res?.translation?.title,
                  description: res?.translation?.description,
                  idTicket: ticket.id,
                  updateDate: ticket.created_date,
                });
                this.populateTickets();
                this.setState({ translateLoading: false });
              }
            });
          } else {
            this.setState({
              ticketTranslatedTitle: filteredTicket?.title,
            });
            this.setState({
              ticketTranslatedDescription: filteredTicket?.description,
            });
          }
        }
      } else {
        this.setState({ translateLoading: true });
        postTranslations(
          {
            title: ticketToTranslate.title,
            description: ticketToTranslate.description,
          },
          language
        ).then(res => {
          if (
            !res ||
            (res && res.ok === false) ||
            (res && res?.status >= 400 && res?.status < 600)
          ) {
            this.setState({
              ticketTranslatedTitle: ticketToTranslate.title,
            });
            this.setState({
              ticketTranslatedDescription: ticketToTranslate.description,
            });
            this.setState({ translateLoading: false });
          } else {
            addTicket({
              title: res?.translation?.title,
              description: res?.translation?.description,
              idTicket: ticket.id,
              updateDate: ticket.created_date,
            });
            this.populateTickets();
            this.setState({ translateLoading: false });
          }
        });
      }
    });
  };

  render() {
    const { ticket } = this.props;
    const {
      ticketTranslatedDescription,
      ticketTranslatedTitle,
      translateLoading,
      clickedTranslate,
      clickedShowOriginal,
    } = this.state;
    const lang = localStorage.getItem('language');

    if (!ticket) {
      return (
        <AppShell noFilterBar {...this.props}>
          <div className="container pXXLarge">
            <div className="hero-unit text-center">
              <EmptyState
                img="/img/report.svg"
                label={
                  <Localized id="no_ticket_found">no_ticket_found</Localized>
                }
              />
            </div>
          </div>
        </AppShell>
      );
    }

    const {
      id,
      subject,
      description,
      owner_extra_info,
      comment,
      is_closed,
      attachment,
      created_date,
      status_extra_info,
    } = ticket;

    return (
      <AppShell noFilterBar {...this.props}>
        <div className="row justify-content-center">
          <div className="col col-12 col-md-10">
            <div className="card border-light mb-4 ticket">
              <div className="card-header ticket-header ticket-card-header">
                <ol className="breadcrumb custom-breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <Localized id="home">home</Localized>
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/tickets">
                      <Localized id="tickets">tickets</Localized>
                    </Link>
                  </li>
                  <li className="breadcrumb-item">{id}</li>
                </ol>
                {this.statusIcon(status_extra_info)}
                {translateLoading ? (
                  <div className="translatingText translate-ticket-text">
                    translating...
                  </div>
                ) : (lang !== 'it-IT' && !clickedShowOriginal) ||
                  clickedTranslate ? (
                  <Button
                    color="primary"
                    className="reportButton ticket-button"
                    onClick={this.showOriginal}
                  >
                    <Globe className="imgReportButton" />
                    <Localized id="report_detail_show_original">
                      report_detail_show_original
                    </Localized>
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    className="reportButton ticket-button"
                    onClick={this.translateTicket}
                  >
                    <Globe className="imgReportButton" />
                    <Localized id="report_detail_translate_btn">
                      report_detail_translate_btn
                    </Localized>
                  </Button>
                )}
              </div>

              <div className="card-body">
                <div className="row">
                  <div className="col col-12 mb-2 col-sm-2 text-sm-center ticket-left">
                    <img
                      className="ticket-avatar img-circle img-responsive"
                      src={owner_extra_info.big_photo}
                      alt=""
                    />
                    <h5 className="ticket-owner">
                      {owner_extra_info.username}
                    </h5>
                  </div>

                  <div className="col col-12 col-sm-10 ticket-right">
                    <h3 className="ticket-right-header">
                      {(lang === 'it-IT' && !clickedTranslate) ||
                      translateLoading
                        ? subject
                        : ticketTranslatedTitle}
                    </h3>
                    <p>
                      {' '}
                      {(lang === 'it-IT' && !clickedTranslate) ||
                      translateLoading
                        ? description
                        : ticketTranslatedDescription}{' '}
                    </p>
                    <Attachments attachments={attachment} />
                    <div className="blog-meta clearfix">
                      <small>
                        {' '}
                        {comment.length}{' '}
                        <Localized id="replies">replies</Localized>{' '}
                      </small>
                      <small>{prettyDate(new Date(created_date))}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col col-12 col-md-10">
            <TicketReplies replies={comment} />
            {!is_closed && (
              <div className="card">
                <div className="card-body">
                  <NewReply {...this.props} is_closed={is_closed} />
                </div>
              </div>
            )}
          </div>
        </div>
      </AppShell>
    );
  }
}
